import customAxios from './customAxios';
import { FETCH_INS_OFFERS, FETCH_REG_PROPS, FETCH_LOCATION, FETCH_INS_COMPANIES, UPDATE_INITIAL_DATA,
         UPDATE_QUESTIONS_POLICY, FETCH_DISTRICTS, SET_SELLECTED_OFFER, SET_TALON_PICTURE, UPDATE_OWNER_DETAILS,
         UPDATE_USER_DETAILS, SET_REVISED_OFFER, UPDATE_SHIPMENT_DETAILS, UPDATE_REVISED_OFFER,
         CREATE_INS_CONTRACT, CREATE_INS_CONTRACT_FAILED, SET_STEP_LIABILITY, SET_GO_TO_LIABILITY, CLEAR_NEW_LIABILITY_POLICY } from "./types";
import {generateFileOptions} from './config';
import * as vehicleService from '../common/services/vehicle.service';
import * as storageService from '../common/services/storage.service';
import {getUserAddresses, updateUserAddress} from './user';
import {blobToFile} from '../../features/pages/components/elements/UploadHelpers';


export const clearNewLiability = () => (dispatch, getState) => {
  dispatch({type: CLEAR_NEW_LIABILITY_POLICY, payload: {}});
}

export const setStepLiability = (step) => (dispatch, getState) => {
  dispatch({type: SET_STEP_LIABILITY, payload: step});
}

export const setGoToLiability = (isTrue) => (dispatch, getState) => {
  dispatch({type: SET_GO_TO_LIABILITY, payload: isTrue});
}

export const updateInitialData = (data) => (dispatch, getState) => {
    dispatch({type: UPDATE_INITIAL_DATA, payload: data});
}

export const updateQuestionsPolicy = (data) => (dispatch, getState) => {
    dispatch({type: UPDATE_QUESTIONS_POLICY, payload: data});
}

export const getRegProps = (plate, talon) => async (dispatch, getState) => {

  //  const params = `plate=${"CA1905A"}&registrationId=${"800112022"}`;

//    const params = `plate=${"CA7632XA"}&registrationId=${"000021009"}`;
//    const params = `plate=${"CB9106PC"}&registrationId=${"011042648"}`; //Йован
// CB6510PB  010377044 

    const params = `plate=${plate}&registrationId=${talon}`;

    const url = `/vins/VInsV2/public/getRegistrationData?${params}`;

    let res;
    try{
      res = await customAxios.get(url);
    } catch (error) {
      console.log(error);
    }

    let payload = {}

    if(res && res.data?.payload) {

      payload = vehicleService.mapRegistrationValues(res.data.payload);

      console.log('mappedData', payload);

    } else if (res && res.data?.messageCode && !res.data?.success) {

      payload = {messageCode: res.data?.messageCode}
      console.log(payload)
    }
    
    dispatch({type: FETCH_REG_PROPS, payload: payload});
  }

  export const updateRegProps = (registrationProps) => (dispatch, getState) => {
  //  console.log('action', registrationProps)
    dispatch({type: FETCH_REG_PROPS, payload: registrationProps});
  }

  export const getDistricts = () => async (dispatch, getState) => {

    const urlDistricts = `/syws-misc/api/address/districts`;

    let resDistricts;

    try{
        resDistricts = await customAxios.get(urlDistricts);
    } catch (error) {
        console.log(error);
    }

    resDistricts = resDistricts?.data ? resDistricts?.data : null;

    dispatch({type: FETCH_DISTRICTS, payload: resDistricts});
  }


  export const getLocation = (plate) => async (dispatch, getState) => {

    const urlDistricts = `/syws-misc/api/address/districts`;

    const plateFirstLetters = vehicleService.getPlateFirstLetters(plate);

    const urlLocations = `/syws-misc/api/address/locations?plate=${plateFirstLetters}`;

    let resDistricts,
        resLocations,
        plateDistrict,
        locationCode,
        locationName,
        payload = null;
    
    try{
        resDistricts = await customAxios.get(urlDistricts);
    } catch (error) {
        console.log(error);
    }

    resDistricts = resDistricts?.data ? resDistricts?.data : null;

    if(resDistricts) {
        plateDistrict = vehicleService.findPlateDistrict(resDistricts, plate);

        //console.log('plateDistrict', plateDistrict)

        try{
            resLocations = await customAxios.get(urlLocations);
        } catch (error) {
            console.log(error);
        }

        resLocations = resLocations?.data ? resLocations?.data : null;

        locationCode = vehicleService.findLocationCode(resLocations, plateDistrict);
        locationName = vehicleService.findLocationName(resLocations, plateDistrict);

        if(locationCode || plateDistrict){
          //  payload = locationCode;
            payload = {locationCode, districtName: plateDistrict, locationName};
        }
    }

    dispatch({type: FETCH_LOCATION, payload: payload});
  }

  export const changeLocation = (locationCode) => (dispatch, getState) => {
    dispatch({type: FETCH_LOCATION, payload: locationCode});
  }

  export const getInsOffersForCompany = (insCompany, revise) => async (dispatch, getState) => {
    const {insVehicleInfo, questionsPolicy, ownerDetails} = getState();
    const {registrationProps, location} = insVehicleInfo || {};

    // console.log('insVehicleInfo',insVehicleInfo)


    const body = revise
                ? vehicleService.mapVehicleInfoForRevisedOffer(registrationProps, location?.locationCode, questionsPolicy, ownerDetails)
                : vehicleService.mapVehicleInfoForOffersFull(registrationProps, location?.locationCode, questionsPolicy);

    const setUrl = (instalments) => `/vins/VInsV2/public/getApplications?provider=${insCompany}&installments=${instalments}`;


    let resOneInstallment,
        resTwoInstallments,
        resFourInstallments,
        payload = {};

    try{
        resOneInstallment   = await customAxios.post(setUrl(1), body);
        resTwoInstallments  = await customAxios.post(setUrl(2), body);
        resFourInstallments = await customAxios.post(setUrl(4), body);
    } catch (error) {
      console.log(error);
    }

    if(resOneInstallment && resOneInstallment.data?.payload) {
        resOneInstallment = resOneInstallment.data.payload;
    }
    if(resTwoInstallments && resTwoInstallments.data?.payload) {
        resTwoInstallments = resTwoInstallments.data.payload;
    }
    if(resFourInstallments && resFourInstallments.data?.payload) {
        resFourInstallments = resFourInstallments.data.payload;
    }

    payload = {
        [insCompany]: {
            1: resOneInstallment    ? resOneInstallment     : null,
            2: resTwoInstallments   ? resTwoInstallments    : null,
            4: resFourInstallments  ? resFourInstallments   : null,
        } 
    }

    console.log('payload', payload);

    dispatch({type: FETCH_INS_OFFERS, payload: payload});
  }

  export const clearInsOffers = (insCompanies) => (dispatch, getState) => {
    const payload = insCompanies.reduce((acc, insCompany) => {
      return {...acc, [insCompany]: null}
    }, {});
        
    dispatch({type: FETCH_INS_OFFERS, payload: payload});
  }

  export const getInsCompanies = () => async (dispatch, getState) => {

    let insCompanies = [];

    const url = `/vins/VInsV2/public/getProviders`;

    let res;

    try{
        res = await customAxios.get(url);
    } catch (error) {
      console.log(error);
    }

    if(res && res.data?.payload) {
      insCompanies = res.data?.payload.map(obj => obj.provider);
    }

    dispatch({type: FETCH_INS_COMPANIES, payload: insCompanies});
  }

  export const setSelectedOffer = (insCompany, installments, totalAmountEUR, totalAmountLEVA) => (dispatch, getState) => {
    const payload = { insCompany, installments, totalAmountEUR, totalAmountLEVA };

    dispatch({type: SET_SELLECTED_OFFER, payload: payload});
  }

  export const setTalonPicture = (data, contentType) => async (dispatch, getState) => {
    
    const {auth} = getState();

    const form = new FormData();

    form.append('file', data);
    form.append('fileType', 'IDENTITY_PIC');

    const boundary = form._boundary;

    //if(!storageService.isValidLoginToken(auth.loginToken)) return;

    const fileOptions = generateFileOptions(auth, boundary);

    const url = `/syws-file/file/uploadMultipart`;

    let res,
    payload = {data, contentType};

    try{
        res = await customAxios.post(url, form, fileOptions);
    } catch (error) {
      console.log(error);
    }

    if(res?.data) {
      //console.log(res.data);
      payload = {...payload, docId: res.data.refNo};
    }

    dispatch({type: SET_TALON_PICTURE, payload: payload});
  }

  export const fetchTalonPicture = (fileUploadId, contentType) => async (dispatch, getState) => {
    
    const url = `/syws-file/file/download/${fileUploadId}`;

    let res, 
    payload = {contentType, docId: fileUploadId};

    try{
        res = await customAxios.get(url,  { responseType: 'blob' });

    } catch (error) {
      console.log(error);
    }

    if(res?.data && !res?.data?.status ) {
      const file = blobToFile(res.data, 'talonPic', contentType)
      payload = {...payload, data: file};

      dispatch({type: SET_TALON_PICTURE, payload: payload});
    } else {
      dispatch({type: SET_TALON_PICTURE, payload: null});
    }

    //console.log(res?.data)
  }

  export const updateOwnerDetails = (data) => (dispatch, getState) => {

    dispatch({type: UPDATE_OWNER_DETAILS, payload: data });
  }
  
  // export const updateUserDetails = (data) => (dispatch, getState) => {

  //   dispatch({type: UPDATE_USER_DETAILS, payload: data });
  // }

  // export const updateUserAddress = (data) => (dispatch, getState) => {
  //   data = data || {};
  //   dispatch({type: UPDATE_USER_ADDRESS, payload: data });
  // }

  export const updateShipmentDetails = (data) => (dispatch, getState) => {

    dispatch({type: UPDATE_SHIPMENT_DETAILS, payload: data });
  }

  export const getRevisedOffer = (insuranceId) => async (dispatch, getState) => {
    const { insOffers : {selectedOffer}, insVehicleInfo, questionsPolicy, ownerDetails} = getState();
    const {registrationProps, location} = insVehicleInfo || {};

    const {insCompany, installments} = selectedOffer || {};
    // for test to change
    //const {insCompany, instalments} = selectedOffer || {insCompany: 'bulins', instalments:[59, 59]};

    const instalment = installments?.length ? installments.length : null;

    //To DO 
    const body = vehicleService.mapVehicleInfoForRevisedOffer(registrationProps, location?.locationCode, questionsPolicy, ownerDetails);

    const url = `/vins/VInsV2/public/getApplications?provider=${insCompany}&installments=${instalment}`;

    let res,
        payload = {};

    try{
        res = await customAxios.post(url, body);

    } catch (error) {
      console.log(error);
    }

    if(res && res.data?.payload) {
      res = res.data.payload;
    }

    payload = {
            insuranceId   : insuranceId || null,
            insCompany    : insCompany,
            installments  : res 
                          ? res.installments 
                          ? res.installments[0]?.valuesEUR 
                          ? res.installments[0]?.valuesEUR 
                          : [] : [] : [],
            commenceDate  : res?.commenceDate,
            contractDate  : res?.contractDate,
            expireDate    : res?.expireDate,
            totalAmount   : res?.totalAmount,
            totalAmountEUR  : res?.totalAmountEUR,
            installmentsLEVA : res 
                            ? res.installments 
                            ? res.installments[0]?.values 
                            ? res.installments[0]?.values
                            : [] : [] : [],
            
    }

    console.log('payload', payload);

    dispatch({type: SET_REVISED_OFFER, payload: payload});
  }

  export const addUserAddress = () => async (dispatch, getState) => {
    const {auth, userDetails} = getState();
    const { userAddress } = userDetails || {};

    if(!auth.loginToken) return;
    
    const body = vehicleService.mapNewUserAddress(userAddress, true);

    const url = `/syws-user/api/user/updateAddress`;

    let res,
    payload = {};

    try{
        res = await customAxios.post(url, body);

    } catch (error) {
      console.log(error);
    }

    if(res?.data && res.data.status === 0) {
      payload = {userAddress: {...userAddress, addressId: res.data.refNo}};
    }

    // console.log(res)

    dispatch({type: UPDATE_USER_DETAILS, payload: payload });
  }

  export const addShipmentAddress = (deliveryAddress) => async (dispatch, getState) => {
    const {auth} = getState();

    if(!storageService.isValidLoginToken(auth.loginToken)) return;
    
    const body = vehicleService.mapNewUserAddress(deliveryAddress, null);

    const url = `/syws-user/api/user/updateAddress`;

    let res,
    payload = {};

    try{
        res = await customAxios.post(url, body);

        await dispatch(getUserAddresses());

    } catch (error) {
      console.log(error);
    }

    if(res?.data && res.data.status === 0) {
      const refNo =  res.data.refNo ? parseInt(res.data.refNo) : null;
      payload = {deliveryAddress: {...deliveryAddress, addressId: refNo}};
    }

    // console.log(res)

    dispatch({type: UPDATE_SHIPMENT_DETAILS, payload: payload });
  }

  export const addOwnerAddress = (ownerAddress) => async (dispatch, getState) => {
    const {auth} = getState();

    if(!storageService.isValidLoginToken(auth.loginToken)) return;
    
    const body = vehicleService.mapNewUserAddress(ownerAddress, null, true);

    const url = `/syws-user/api/user/updateAddress`;

    let res,
    payload = {};

    try{
        res = await customAxios.post(url, body);

        await dispatch(getUserAddresses());

    } catch (error) {
      console.log(error);
    }

    if(res?.data && res.data.status === 0) {
      const refNo =  res.data.refNo ? parseInt(res.data.refNo) : null;
      payload = {ownerAddress: {...ownerAddress, addressId: refNo}};
    }

    // console.log(res)

    dispatch({type: UPDATE_OWNER_DETAILS, payload: payload });
  }

  export const createOrUpdateDraftInsContract = () => async (dispatch, getState) => {
    const state  = getState();
    const {auth} = state;

    if(!storageService.isValidLoginToken(auth.loginToken)) return console.log('No valid login token');

    const body = vehicleService.mapBodyForCreateContract(state);

    const url = `/syws-ins-vehicle/api/insVehicle/insContract/create`;

    let res,
    payload = null;

    try{
        res = await customAxios.post(url, body);
    } catch (error) {
      console.log(error);
    }
    
    if(res?.data && res.data.refNo) {
      //console.log(res.data)
      payload = res.data.refNo;
    } else {
      return dispatch({type: CREATE_INS_CONTRACT_FAILED, payload: true });
    }

    dispatch({type: CREATE_INS_CONTRACT, payload: payload });
  }
  
  export const deleteInsContract = (insuranceId) => async (dispatch, getState) => {
  
    const params = `insuranceId=${insuranceId}`;

    const url = `/syws-ins-vehicle/api/insVehicle/insContract/delete?${params}`;

    let res;
    try{
      res = await customAxios.get(url);
    } catch (error) {
      console.log(error);
    }

    if(res?.data && res?.data.ststus === 0) {
      console.log(`Insurance contract with Id = ${insuranceId} deleted` );
    }
  }

  export const updateRevisedOffer = (insuranceId, insCompany, dueAmount) => (dispatch, getState) => {
    const data = {insCompany, insuranceId, installments: dueAmount? [dueAmount] : []}
    dispatch({type: UPDATE_REVISED_OFFER, payload: data });
  }

  export const setTalonUploadId = (data) => (dispatch, getState) => {
    dispatch({type: SET_TALON_PICTURE, payload: data});
  }

  export const restorePolicyDataAfterPayAtempt = (policy, cashflowId) => async (dispatch, getState) => {
    if(!policy) return;

    const {userDetails: {userAddresses}} = getState();

    const regProps = policy?.registrationProps || {};
    const questions = policy?.questions || {};
    const plate = regProps?.plate?.value;
    const talon = regProps?.ownerCertNo?.value;
    const insuranceId = policy?.insuranceId;
    const insCompany = policy?.insCompany;
    const shipmentDetails = policy?.deliveries ? policy?.deliveries.find(obj => obj.cashflowId === parseInt(cashflowId)) : null; 

    const cashflow = policy?.cashflows ? policy?.cashflows.find(obj => obj.cashflowId === parseInt(cashflowId) ) : {};

    const dueAmount = cashflow.dueAmount;

    let insurancePerson = policy?.insurancePerson[0];

    const {familyCyr, nameCyr, surnameCyr} = insurancePerson || {};

    insurancePerson = {...insurancePerson, firstNameCyrillic: nameCyr, middleNameCyrillic: surnameCyr, lastNameCyrillic: familyCyr }

    const ownerAddressId = policy?.insurancePerson[0] ? policy?.insurancePerson[0].addressId : null;

    const ownerAddress = ownerAddressId && userAddresses ? userAddresses.find(obj => obj.addressId === ownerAddressId) : null;

    const userAddress = userAddresses ? userAddresses.find(obj => obj.isUserAddress) : null;

    if(userAddress) {
      await dispatch(updateUserAddress(userAddress))
    }

    await dispatch(updateRegProps(regProps));

    await Promise.all([
      dispatch(updateInitialData({plate, talon, registered: true})),
      dispatch(getLocation(plate)),
      dispatch(getInsCompanies()),
    ]);

    await dispatch(updateQuestionsPolicy(questions));


    if(policy?.insuranceDocuments?.length) {
      const talonDoc  = policy?.insuranceDocuments.find(doc => doc.docType === 'TALON')
    
      if(talonDoc && talonDoc?.fileUploadId > 0) {
        let data = {docId: talonDoc?.fileUploadId, contentType: talonDoc?.contentType }

        await dispatch(setTalonUploadId(data));
      }
    }

    if(shipmentDetails) {
      const {receiverName, receiverPhone, receiverAddInfo, cashflowId, addressId} = shipmentDetails;
      const shipmentAddress = userAddresses ? userAddresses.find(obj => obj.addressId === addressId) : {addressId};
      const data = {receiverName, receiverPhone, receiverAddInfo, cashflowId, deliveryAddress: shipmentAddress};

      await dispatch(updateShipmentDetails(data));
    }

    if(ownerAddress) {
      await dispatch(updateOwnerDetails({...insurancePerson, ownerAddress: ownerAddress}));
    } else if(insurancePerson) {
      await dispatch(updateOwnerDetails({...insurancePerson}));
    }

    await dispatch(updateRevisedOffer(insuranceId, insCompany, dueAmount));
  }